import { FormControl, TextField, TextFieldProps } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import _ from 'lodash';
import './../../components/common/v2/Styles/__styles.css';

type IProps = {
  value?: number | string | any;
  onChange: (event: any) => void;
  key?: string;
  minDate?: number | string | any;
  maxDate?: number | string | any;
  height?: string;
  _shouldDisableDate?: (date: Date) => boolean;
} & TextFieldProps;

const LOSDateField = ({
  value,
  maxDate,
  name,
  onChange,
  minDate,
  height,
  _shouldDisableDate,
  ...inputProps
}: IProps) => {
  return (
    <>
      <FormControl
        fullWidth
        sx={{ height: height ?? '35px', fontFamily: 'Aspekta !important' }}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label={''}
            value={value}
            onChange={onChange}
            inputFormat="DD-MM-YYYY"
            minDate={minDate}
            maxDate={maxDate}
            shouldDisableDate={(dateParam: any) => {
              const dayOfMonth = dateParam.$D;
              const month = dateParam.$M + 1;
              const year = dateParam.$y;
              if (_shouldDisableDate) {
                return _shouldDisableDate(new Date(year, month, dayOfMonth));
              }
              return false;
            }}
            renderInput={(params) => (
              <TextField
                size="medium"
                style={{
                  borderRadius: '15px',
                  height: height ?? '35px',
                  fontFamily: 'Aspekta !important',
                }}
                InputProps={{
                  style: {
                    borderRadius: '15px',
                    fontFamily: 'Aspekta !important',
                  },
                }}
                sx={{
                  fontFamily: 'Aspekta !important',
                  '& .MuiInputBase-root': {
                    height: '100%',
                    fontFamily: 'Aspekta !important',

                    '& .MuiInputBase-input': {
                      fontFamily: 'Aspekta !important',
                      fontWeight: '400 !important',
                      fontSize: '0.75rem',
                    },
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderRadius: '9px !important',
                    fontFamily: 'Aspekta !important',
                  },
                  '& .MuiInputLabel-root': {
                    fontFamily: 'Aspekta !important',
                  },
                }}
                fullWidth
                InputLabelProps={{
                  style: {
                    color: '#AFAFAF',
                    textAlign: 'center',
                    fontFamily: 'Aspekta !important',
                  },
                }}
                {...params}
                className="font-aspekta-400"
                {...inputProps}
              />
            )}
          />
        </LocalizationProvider>
      </FormControl>
    </>
  );
};

export default LOSDateField;
